import apiRoutes from '../../../routes/admin_api_routes.json'
import { handleApiError } from '../../util/parse_server_error'
import { setFetched } from '../api/actions'

export function fetchMeetings(topicId) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_topic_meetings.path
    const url = path.replace(':topic_id', topicId)
    return axios()
      .get(url)
      .then(
        (result) => {
          dispatch(setFetched('meetings', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function createMeeting(topicId, data) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_topic_meetings.path
    const url = path.replace(':topic_id', topicId)
    return axios()
      .post(url, data)
      .then(
        (result) => {
          dispatch(setFetched('meetings', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function updateMeeting(topicId, meetingId, data) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_topic_meeting.path
    const url = path.replace(':topic_id', topicId).replace(':id', meetingId)
    return axios()
      .put(url, data)
      .then(
        (result) => {
          dispatch(setFetched('meetings', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
            uniqueKey: meetingId,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function cancelMeeting(topicId, meetingId) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_topic_meeting.path
    const url = path.replace(':topic_id', topicId).replace(':id', meetingId)
    return axios()
      .delete(url)
      .then(
        (result) => {
          dispatch(setFetched('meetings', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
            uniqueKey: meetingId,
          })
          return Promise.reject(result)
        },
      )
  }
}
